import React from 'react';

export default function QuotationCommercialOfferPage({ commercialSection = {}, termsSection = {}, signatory = {} }) {
  const priceRows = commercialSection.tables?.[0]?.rows || [];
  const groups = commercialSection.commercialOfferGroups || [];
  const pricing = commercialSection.pricing || {};

  const formatPrice = (n) => {
    if (n == null) return '—';
    return `₹ ${Number(n).toLocaleString('en-IN')}`;
  };

  const hasGroups = groups.length > 0;

  return (
    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-no-break" style={{ marginBottom: 18 }}>
          <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 700, color: '#000814', margin: '0 0 4px 0' }}>
            COMMERCIAL OFFER
          </h2>
          <div className="quotation-yellow-divider" />
        </div>

        <div className="quotation-section-block">
        {hasGroups ? (
          <>
            {groups.map((grp, gi) => (
              <div key={grp.id} style={{ marginBottom: 20 }}>
                <table className="quotation-table" style={{ marginBottom: 8, fontSize: 13 }}>
                  <thead>
                    <tr>
                      <th style={{ width: 60 }}>S. No.</th>
                      <th>Item</th>
                      <th style={{ width: 100, textAlign: 'center' }}>Quantity</th>
                      <th style={{ width: 120, textAlign: 'right' }}>Price (Rs.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grp.items.map((row, i) => (
                      <tr key={i}>
                        <td>{row.sno ?? i + 1}</td>
                        <td>{row.title}</td>
                        <td style={{ textAlign: 'center' }}>{row.quantity} set(s)</td>
                        <td style={{ textAlign: 'right' }}>{formatPrice(row.lineTotal)}</td>
                      </tr>
                    ))}
                    <tr style={{ background: '#f0f0f0' }}>
                      <td colSpan={3} style={{ textAlign: 'right' }}><strong>Subtotal</strong></td>
                      <td style={{ textAlign: 'right' }}><strong>{formatPrice(grp.subtotal)}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
            <table className="quotation-table" style={{ marginBottom: 18, fontSize: 13 }}>
              <tbody>
                <tr className="quotation-total-row">
                  <td colSpan={3} style={{ textAlign: 'right' }}><strong>Grand Total</strong></td>
                  <td style={{ textAlign: 'right' }}><strong>{formatPrice(pricing.grand_total)}</strong></td>
                </tr>
              </tbody>
            </table>
          </>
        ) : (
        <table className="quotation-table" style={{ marginBottom: 18, fontSize: 13 }}>
          <thead>
            <tr>
              <th style={{ width: 60 }}>S. No.</th>
              <th>Item</th>
              <th style={{ width: 100, textAlign: 'center' }}>Quantity</th>
              <th style={{ width: 120, textAlign: 'right' }}>Price (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            {priceRows.map((row, i) => (
              <tr key={i}>
                <td>{row.item ?? i + 1}</td>
                <td>{row.description}</td>
                <td style={{ textAlign: 'center' }}>{row.quantity}</td>
                <td style={{ textAlign: 'right' }}>{formatPrice(row.price)}</td>
              </tr>
            ))}
            {(pricing.item_1_to_4_total != null || pricing.item_5_to_11_total != null) && (
              <>
                <tr style={{ background: '#f0f0f0' }}>
                  <td colSpan={3} style={{ textAlign: 'right' }}><strong>Item 1 to 4</strong></td>
                  <td style={{ textAlign: 'right' }}><strong>{formatPrice(pricing.item_1_to_4_total)}</strong></td>
                </tr>
                <tr style={{ background: '#f0f0f0' }}>
                  <td colSpan={3} style={{ textAlign: 'right' }}><strong>Item 5 to 11</strong></td>
                  <td style={{ textAlign: 'right' }}><strong>{formatPrice(pricing.item_5_to_11_total)}</strong></td>
                </tr>
              </>
            )}
            <tr className="quotation-total-row">
              <td colSpan={3} style={{ textAlign: 'right' }}><strong>Total</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{formatPrice(pricing.grand_total)}</strong></td>
            </tr>
          </tbody>
        </table>
        )}
        </div>

        <div className="quotation-section-block">
        {hasGroups && pricing.groupBreakup?.length > 0 ? (
          pricing.groupBreakup.map((grp, i) => (
            <p key={grp.label} style={{ fontSize: 13, color: '#333', margin: i === 0 ? '0 0 8px 0' : '0 0 12px 0' }}>
              {grp.label}: {formatPrice(grp.total)} ({grp.in_words || ''})
            </p>
          ))
        ) : (pricing.item_1_to_4_total != null || pricing.item_5_to_11_total != null) ? (
          <>
            <p style={{ fontSize: 13, color: '#333', margin: '0 0 8px 0' }}>
              Item 1 to 4: {formatPrice(pricing.item_1_to_4_total)} ({pricing.item_1_to_4_in_words || ''})
            </p>
            <p style={{ fontSize: 13, color: '#333', margin: '0 0 12px 0' }}>
              Item 5 to 11: {formatPrice(pricing.item_5_to_11_total)} ({pricing.item_5_to_11_in_words || ''})
            </p>
          </>
        ) : null}
        <p style={{ fontSize: 14, fontWeight: 700, color: '#000814', margin: '0 0 16px 0' }}>
          Total: {formatPrice(pricing.grand_total)} ({pricing.grand_total_in_words || ''})
        </p>
        </div>

        {/* ── Trust widgets ───────────────────────────────────────────── */}

        {/* Stats strip */}
        <div className="quotation-no-break" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0, marginBottom: 20, border: '1px solid #e0e0e0', borderRadius: 6, overflow: 'hidden' }}>
          {[
            { number: '14+',  label: 'Years of Experience' },
            { number: '375+', label: 'Plants Installed' },
            { number: '350+', label: 'Satisfied Clients' },
            { number: 'PAN',  label: 'India Service Network' },
          ].map((stat, i, arr) => (
            <div key={stat.label} style={{ padding: '14px 10px', textAlign: 'center', background: i % 2 === 0 ? '#000814' : '#ffbe0b', borderRight: i < arr.length - 1 ? '1px solid rgba(255,255,255,0.15)' : 'none' }}>
              <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 22, fontWeight: 700, color: i % 2 === 0 ? '#ffbe0b' : '#000814', lineHeight: 1 }}>
                {stat.number}
              </div>
              <div style={{ fontSize: 11, fontWeight: 600, color: i % 2 === 0 ? '#fff' : '#000814', marginTop: 4, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Why Choose Us */}
        <div className="quotation-no-break" style={{ marginBottom: 20 }}>
          <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 14, fontWeight: 700, color: '#000814', margin: '0 0 4px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Why Choose Us
          </h3>
          <div style={{ height: 2, width: 40, background: '#ffbe0b', marginBottom: 12 }} />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {[
              { icon: '◈', title: 'Premium Quality Manufacturing', desc: 'All components are precision-engineered and quality-tested to deliver consistent, long-lasting performance.' },
              { icon: '◉', title: 'Turnkey Plant Solutions', desc: 'From design to installation, we manage every aspect of your powder coating plant setup.' },
              { icon: '◎', title: 'Expert After-Sale Support', desc: 'Dedicated service team and comprehensive operator training ensure smooth operations post-installation.' },
              { icon: '◆', title: 'Custom-Built to Your Specs', desc: 'Every system is engineered to your production capacity, component size, and workshop layout.' },
            ].map((item) => (
              <div key={item.title} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 12px', background: '#f5f7fa', borderRadius: 5, border: '1px solid #e8eaed' }}>
                <div style={{ fontSize: 18, color: '#ffbe0b', lineHeight: 1, flexShrink: 0, marginTop: 1 }}>{item.icon}</div>
                <div>
                  <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700, color: '#000814', marginBottom: 3 }}>{item.title}</div>
                  <div style={{ fontSize: 11, color: '#555', lineHeight: 1.5 }}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Commitment strip */}
        <div className="quotation-no-break" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 4 }}>
          {[
            { icon: '✦', title: 'Good Warranty Period', desc: 'On structure and mechanical components from the date of commissioning.' },
            { icon: '✦', title: 'On-Site Installation', desc: 'Commissioning carried out by our factory-trained engineers at your facility.' },
            { icon: '✦', title: 'Operator Training', desc: 'Hands-on training provided to your team for efficient day-to-day operation.' },
          ].map((item) => (
            <div key={item.title} style={{ padding: '10px 12px', borderLeft: '3px solid #ffbe0b', background: '#fffdf0' }}>
              <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700, color: '#000814', marginBottom: 4 }}>
                {item.icon} {item.title}
              </div>
              <div style={{ fontSize: 11, color: '#555', lineHeight: 1.5 }}>{item.desc}</div>
            </div>
          ))}
        </div>

        {/* <div className="quotation-section-block" style={{ marginBottom: 14 }}>
          <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600, fontSize: 16, color: '#000814', margin: '0 0 10px 0' }}>
            Terms & Conditions
          </h3>
          {termsItems.map((item, i) => (
            <p key={i} style={{ fontSize: 12, color: '#333', lineHeight: 1.45, margin: '0 0 6px 0' }}>
              {item.text}
            </p>
          ))}
        </div>

        <div style={{ height: 1, background: '#ddd', margin: '16px 0' }} />

        {(closingContent.length > 0 || signatory.name) && (
          <div className="quotation-section-block" style={{ marginTop: 14 }}>
            {closingContent.map((p, i) => (
              <p key={i} style={{ fontSize: 13, color: '#333', margin: '0 0 6px 0' }}>{p}</p>
            ))}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginTop: 20, alignItems: 'end' }}>
              <div>
                <p style={{ fontSize: 13, color: '#666', margin: '0 0 24px 0' }}>Authorized Signatory</p>
                <div style={{ borderTop: '1px solid #000814', paddingTop: 8 }}>
                  <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 13, color: '#000814', margin: 0 }}>
                    {signatory.name || 'Harish Sharma'}
                  </p>
                  <p style={{ fontSize: 13, color: '#666', margin: '4px 0 0 0' }}>{signatory.contact || '+919811846214'}</p>
                  <p style={{ fontSize: 13, color: '#666', margin: '2px 0 0 0' }}>{signatory.designation || 'Director'}</p>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: 13, color: '#666', margin: '0 0 8px 0' }}>{signatory.date || 'May 3, 2025'}</p>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
}
